module.exports = __webpack_public_path__ + "img/DE00861.1aafccfa.png";